import Environment from '../../../Environment';
import { useContext } from 'react';
import AppContext from '../../../AppContext';

interface DashboardLinkProps {
  linkText: string;
  relativeUrl: string;
}

export default function DashboardLink({ linkText, relativeUrl }: DashboardLinkProps) {
  const { year, cocode } = useContext(AppContext);

  return (
    <a
      href={`${Environment.ISITE_URL()}/profile/html/fastrdisplay.html?&YEAR=${year}&COCODE=${cocode}${relativeUrl}`}
      target="_blank"
      rel="noreferrer">
      {linkText}
    </a>
  );
}
